<template>
  <div class="import_container">
    <v-tabs v-model="tab" color="primary" slider-color="primary">
      <v-tab>
        <div class="tab_label" v-text="$t('client.list')" />
      </v-tab>
      <v-tab>
        <div class="tab_label" v-text="$tc('organization.folder', 3)" />
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <ContactImport :organization-id="organizationId" />
      </v-tab-item>
      <v-tab-item>
        <FolderImport :organization-id="organizationId" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import ContactImport from "@/modules/Admin/Components/ContactImport.vue";
import FolderImport from "@/modules/Admin/Components/FolderImport.vue";

export default {
  name: "ImportPage",
  components: {
    ContactImport,
    FolderImport,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style>
.import_container {
  padding: 24px;
  background: #fff;
}
</style>
